import moment from 'moment';

// convert unix ms timestamp into moment time object
export default function(dt) {
  if (!dt) return '';
  return moment(dt);
}
